import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { GenericDialogService } from '../../../services/ui/generic-dialog.service';
import { TemplateOverviewResponse } from '../../api/templates';
import { VorlageActionType } from '../vorlagen-aktionen/vorlage-action-type.enum';

@Component({
  selector: 'app-vorlagen-uebersicht-table',
  templateUrl: './vorlagen-uebersicht-table.component.html',
  styleUrls: ['./vorlagen-uebersicht-table.component.scss'],
})
export class VorlagenUebersichtTableComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild(MatSort) sort!: MatSort;

  @Input() noticeTemplateOverviews: TemplateOverviewResponse[];
  @Input() iAmOwner: boolean;
  @Output() clickActionType = new EventEmitter<{ templateId: number; actionType: VorlageActionType }>();
  @Output() clickEditName = new EventEmitter<number>();

  dataSource: MatTableDataSource<TemplateOverviewResponse> = new MatTableDataSource();
  displayedColumns = [
    'noticeSubTypeCode',
    'name',
    'description',
    'customizationId',
    'lastEditedAt',
    'actions',
  ];

  constructor(private genericDialogService: GenericDialogService) {
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.noticeTemplateOverviews);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.noticeTemplateOverviews?.currentValue) {
      this.dataSource.data = changes.noticeTemplateOverviews.currentValue;
    }
  }

  onClickActionType({ templateId, actionType }) {
    if (actionType === VorlageActionType.EDIT_TEMPLATE_NAME) {
      this.clickEditName.emit(templateId);
    } else {
      this.clickActionType.emit({ templateId, actionType });
    }
  }

  onClickWarnIcon() {
    this.genericDialogService.openWarningDialog(
      'Aktualisierung des eForms-Standards',
      'Verstanden',
      '<p>Der eForms-Standard wurde aktualisiert, seit diese Vorlage das letzte Mal bearbeitet wurde. </p>' +
      '<p>Mit der Aktion "Vorlage bearbeiten" können Sie die Vorlage öffnen, bearbeiten und gemäß des neuen eForms-Standards speichern. Danach können Sie die Vorlage wie gewohnt weiter nutzen.</p>',
    );
  }
}
